import { createFileRoute } from "@tanstack/react-router";

import Main from "/src/routes/admin/main";
import { adminListSearchSchema } from "/src/routes/admin/org/list/adminListSearch";

export type { AdminSearch } from "/src/routes/admin/org/list/adminListSearch";

export const Route = createFileRoute("/_main/admin")({
  validateSearch: adminListSearchSchema,
  component: Main,
});
